
export const UPDATE_SHIPPING_BILL = {
    REQUEST: 'PRODUCT_RETURN.UPDATE_SHIPPING_BILL.REQUEST',
    SUCCESS: 'PRODUCT_RETURN.UPDATE_SHIPPING_BILL.SUCCESS',
    FAILED: 'PRODUCT_RETURN.UPDATE_SHIPPING_BILL.FAILED',
};
